import { DialogActions, DialogContent } from '@mui/material';
import { Modal } from '../../../../../ui/components/pure/modal/modal.component';
import { useQueryGetProject } from '../../../../../core/queries/projects.queries';
import { TextButton } from '../../../../../ui/components/pure/text-button/text-button.component';
import { ProjectTeamMemberDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Alert, AlertTitle } from '@mui/material';
import { parseErrorMessage } from '../../../../../core/api/api.context';
import { useResendInviteAction } from './resend-invite-action.hook';

export interface ResendInviteModalProps {
  projectID: any;
  user: ProjectTeamMemberDto & { invitationID: string };
  onClose: () => void;
  onSuccess: () => void;
}

export function ResendInviteModal({ projectID, user, onClose, onSuccess }: ResendInviteModalProps) {
  const project = useQueryGetProject(projectID);
  const [state, handlers] = useResendInviteAction({
    invitationID: user.invitationID,
    projectID: projectID,
    user: user,
    onClose: onClose,
    onSuccess: onSuccess
  });

  return (
    <Modal
      open={true}
      title={`Resend invitation to ${user.displayName}`}
      loading={project.isLoading}
      onClose={onClose}
      maxWidth="xs"
    >
      <DialogContent style={{ padding: '16px 24px', fontSize: '14px' }}>
        {state.error && (
          <p>
            <Alert variant="outlined" severity="error">
              <AlertTitle>Something went wrong</AlertTitle>
              {parseErrorMessage(state.error.message)}
            </Alert>
          </p>
        )}
        <p style={{ paddingBottom: '36px' }}>
          Continuing will resend an invitation for {user.firstName} to join the{' '}
          {project.data ? project.data.name : 'project'} team with &lsquo;{user.accessLevelName}&rsquo; access.
        </p>
      </DialogContent>
      <DialogActions style={{ borderTop: '1px solid #EBEDF2', padding: '16px 24px' }}>
        <TextButton color="secondary" variant="outlined" onClick={handlers.onCancelIntent}>
          Cancel
        </TextButton>
        <TextButton color="primary" variant="outlined" onClick={handlers.onConfirmResendInvite}>
          Resend
        </TextButton>
      </DialogActions>
    </Modal>
  );
}
